import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, Paper } from '@material-ui/core';
import { useForm } from "../../../../hooks/useForm";
import { CboProfesionales } from '../../../cbos/CboProfesionales';
import { ModificarUsuarioOspe } from './ModificarUsuarioOspe';
import { getAbmUsuarioPorIdProfesional, limpiarAbmUsuarioPorIdProfesional, updateUsuarioOspeTurb001 } from '../../../../actions/turnos/abmUsuarioPorIdProfesional';

const useStyles = makeStyles({
    root: {
        padding:10,
        flexGrow: 1,
        marginTop:10,
    },
    input: {
        padding: 10,
    },
    grid: {
        padding: 10,
        marginBottom: 10,
        backgroundColor: 'white',
    },
});

const stateInitial = {
    idProfesional: null,
}

export const HomeParametrizacionUsuarioOspe = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items } = useSelector((state) => state.efectoresP);
    const { usuario } = useSelector((state) => state.abmUsuarioPorIdProfesional);
    const { centrosMedicos: centrosMedicosUsuario } = useSelector( state => state.auth );

    const [ efectorP, setEfectorP ] = useState();
    const [formValues, handleInputChange] = useForm(stateInitial);
    const { idProfesional } = formValues;

    useEffect(() => {
        
        setEfectorP( items.find(s => s.idEfectorRed === idProfesional) );
    }, [idProfesional, items]);

    useEffect(() => {
        dispatch(limpiarAbmUsuarioPorIdProfesional());
        if(idProfesional !== null)
            dispatch(getAbmUsuarioPorIdProfesional(idProfesional));
    }, [dispatch, idProfesional]);
    
    const handleActualizarUsuarioTurb = () => {
        dispatch(updateUsuarioOspeTurb001(idProfesional));
    };

    return ( 
        <Grid container className={classes.root} justify="center" spacing={1}> 
            <Grid container xs={12} justify="flex-end">
                <Button 
                    variant='contained' 
                    color='primary' 
                    size="medium"
                    style={{marginRight:10, padding: 10}}
                    onClick={handleActualizarUsuarioTurb}
                    disabled={!usuario.length>0  || !idProfesional}
                >
                    Actualizar Usuario Ospe en Turb001
                </Button>         
            </Grid> 
            <Grid item xs={8}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={12} md={6}>
                        <Paper className={classes.input}>
                            <CboProfesionales 
                                manejadorInputChange={handleInputChange}
                                filtrarPorUsuario={true}
                                valor={idProfesional}
                                autocomplete={true}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            {efectorP && usuario &&
                <Grid item xs={8} style={{marginTop: 10}}>
                    <Grid container direction="column">
                        {usuario.map( u =>  
                            <>
                                {centrosMedicosUsuario.filter(i => i.idCentroMedico === u.idCentroMedico).length>0 &&
                                    <ModificarUsuarioOspe
                                        descripcion={u.especialidad}
                                        idCentroMedico={u.idCentroMedico}
                                        idEfector={u.idEfector}
                                        idEspecialidad={u.idEspecialidad}
                                        userName={u.userName}
                                        centroMedico={u.centroMedico}
                                    />
                                }
                            </>
                        )}
                    </Grid>
                </Grid>
            }
        </Grid> 
     );
}

